/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["li[_ngcontent-%COMP%]:nth-child(2n), p[_ngcontent-%COMP%]:nth-child(2n){background-color:#ffffe0}.ellipsis[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"];
export { styles as styles };

